import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useStyles } from './shared-warning-styles.js';
import { VITESSCE_CONTAINER } from './classNames.js';
export function Warning(props) {
    const { title, preformatted, unformatted, } = props;
    const { classes } = useStyles();
    return (_jsx("div", { className: VITESSCE_CONTAINER, children: _jsx("div", { className: clsx(classes.warningLayout, classes.containerFluid), children: _jsx("div", { className: classes.row, children: _jsxs("div", { className: classes.warningCard, children: [_jsx("h1", { children: title }), preformatted ? (_jsx("pre", { children: preformatted })) : null, _jsx("p", { children: unformatted })] }) }) }) }));
}
//# sourceMappingURL=Warning.js.map